"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionContext = exports.AuthContext = void 0;
const react_1 = __importStar(require("react"));
const SSO = __importStar(require("@dcl/single-sign-on-client"));
const isURL_1 = __importDefault(require("validator/lib/isURL"));
const useAuth_1 = __importDefault(require("../../hooks/useAuth"));
const useTransaction_1 = __importDefault(require("../../hooks/useTransaction"));
const defaultAuthState = [
    null,
    {
        selecting: false,
        loading: true,
        chainId: null,
        providerType: null,
        provider: null,
        error: null,
        switchTo: () => { },
        select: () => { },
        connect: () => { },
        authorize: () => { },
        disconnect: () => { },
    },
];
const defaultTransactionState = [
    [],
    {
        add: () => { },
        clear: () => { },
    },
];
exports.AuthContext = (0, react_1.createContext)(defaultAuthState);
exports.TransactionContext = (0, react_1.createContext)(defaultTransactionState);
exports.default = react_1.default.memo(function AuthProvider({ sso, children, }) {
    const auth = (0, useAuth_1.default)();
    const transactions = (0, useTransaction_1.default)(auth[0], auth[1].chainId);
    // TODO: Remove after all dApps get the user identity from localhost
    // Initialize SSO
    // Will only be initialized if the sso url is provided.
    // If the url is not provided, the identity of the user will be stored in the application's local storage instead of the sso local storage.
    (0, react_1.useEffect)(() => {
        if (sso && (0, isURL_1.default)(sso)) {
            SSO.init(sso);
        }
    }, []);
    return (react_1.default.createElement(exports.AuthContext.Provider, { value: auth },
        react_1.default.createElement(exports.TransactionContext.Provider, { value: transactions }, children)));
});
